import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { TabProps } from "./Tab.types";

const BasicTabStyles =
  "inline-flex items-center gap-x-2 whitespace-nowrap border-b-2 border-gray-500 px-3 py-3 text-sm text-gray-500 hover:text-primary-600 focus:text-primary focus:outline-none disabled:pointer-events-none disabled:opacity-50";
const BorderedTabStyles =
  "py-1.5 px-4 inline-flex items-center gap-x-2 bg-transparent text-sm text-gray-500 focus:outline-none hover:text-primary-600 focus:text-primary font-medium rounded hover:text-primary disabled:opacity-50 disabled:pointer-events-none";

const Tab = forwardRef<HTMLButtonElement, PropsWithChildren<TabProps>>(
  (
    { tabObject, tabType, isActive, onTabChange, ...tabProps },
    forwardedRef,
  ) => {
    const { id, label } = tabObject;

    return (
      <button
        ref={forwardedRef}
        id={id}
        type="button"
        className={cn(
          tabType === "basic" ? BasicTabStyles : BorderedTabStyles,
          {
            "border-primary-600 font-semibold text-primary-600 focus:border-primary":
              isActive && tabType === "basic",
            "bg-white font-bold text-primary-600":
              isActive && tabType === "bordered",
          },
        )}
        onClick={() => onTabChange(id)}
        role="tab"
        {...tabProps}
      >
        {label}
      </button>
    );
  },
);

Tab.displayName = "Tab";

export default Tab;
